import Chart from "chart.js/auto";

const customBackgroundColor = {
  id: "customBackgroundColor",
  beforeDraw: (chart, args, options) => {
    const { ctx } = chart;
    ctx.save();
    ctx.globalCompositeOperation = "destination-over";
    ctx.fillStyle = options.color || "#ffffff";
    ctx.fillRect(0, 0, chart.width, chart.height);
    ctx.restore();
  },
};

export default (config) => ({
  chart: null,
  config: config,
  init() {
    const data = {
      labels: this.config.labels,
      datasets: this.config.datasets,
    };

    const config = {
      plugins: [customBackgroundColor],
      type: "bar",
      data: data,
      options: {
        plugins: {
          title: {
            display: false,
            text: this.config.title ?? "",
          },
          legend: {
            display: false,
          },
        },
        responsive: true,
        interaction: {
          intersect: false,
        },
        scales: {
          x: {
            grid: {
              display: false,
            },
            stacked: true,
          },
          y: {
            min: 0,
            grid: {
              display: true,
            },
            beginAtZero: false,
            ticks: {
              callback: function (value, index, ticks) {
                return "$" + value;
              },
            },
            stacked: true,
          },
        },
      },
    };
    this.chart = new Chart(this.$refs.chart, config);
  },
});
